const bannerPath = "/api/v1/BannerWidget/{widgetId}/preview/detail";
const productPath = "/api/v1/ProductWidget/{widgetId}/preview/detail";
// https://widget.affilio.ir/api/v1/ProductWidget/4809241039291353571/preview/detail

const detectHostUrl = () => {
  const host = window.location.host;

  if (host === "stage.affilio.ir" || process.env.NODE_ENV === "development") {
    return "https://client-api-stage.affilio.ir";
  }
  // return "https://client-api.affilio.ir";
  // return "https://panel.affilio.ir";
  return "https://widget.affilio.ir";
};

export const baseApi = (type, body) => {
  const host = detectHostUrl();
  let path = type === "ProductWidget" ? productPath : bannerPath;
  let url = host + path;
  url = url.replace("{widgetId}", body.widget_id);

  return fetch(url, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).then((response) => response.json());
};
